"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSizeme = _interopRequireDefault(require("react-sizeme"));

var _md = _interopRequireDefault(require("md5"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _set2 = _interopRequireDefault(require("lodash/set"));

var _once2 = _interopRequireDefault(require("lodash/once"));

var _style = _interopRequireDefault(require("./style.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class Component extends _react.default.Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "getHash", (0, _once2.default)(() => {
      let xpath = '';

      const getNode = node => {
        xpath = (node.type.name || '') + '_' + xpath;

        if (node._debugOwner) {
          getNode(node._debugOwner);
        }
      };

      getNode(this._reactInternalFiber);
      const hash = (0, _md.default)(window.location.path + ':' + xpath + ':' + this.props.handle).substr(-5);
      return hash;
    }));

    _defineProperty(this, "getCachedWidth", () => {
      const hash = this.getHash();
      return (0, _get2.default)(window, `cccisd.components.responsive.${hash}.width`);
    });

    _defineProperty(this, "getClassName", () => {
      const _this$props = this.props,
            size = _this$props.size,
            stylesheet = _this$props.stylesheet,
            widthBreakpoints = _this$props.widthBreakpoints;

      if (!stylesheet) {
        return '';
      }

      const width = size.width || this.getCachedWidth();

      if (!width) {
        return '';
      }

      let result = '';

      if (width < widthBreakpoints.xsmall) {
        result = stylesheet.xsmall || '';
      } else if (width <= widthBreakpoints.small) {
        result = stylesheet.small || '';
      } else if (width <= widthBreakpoints.medium) {
        result = stylesheet.medium || '';
      } else {
        result = stylesheet.large || '';
      }

      return result;
    });
  }

  componentDidUpdate(prevProps) {
    // save width in cache
    if (this.props.size.width !== prevProps.size.width && typeof this.props.size.width === 'number' && this.props.size.width > 0) {
      const hash = this.getHash();
      (0, _set2.default)(window, `cccisd.components.responsive.${hash}.width`, this.props.size.width);
    }
  }
  /** Calculate hash based on the DOM path to the component */


  render() {
    const isWidthCalculated = typeof this.props.size.width === 'number' || typeof this.getCachedWidth() === 'number';
    const size = this.props.size;
    const width = size.width || this.getCachedWidth(); // We need extra div to calculate size properly

    const result = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: this.getClassName(),
      style: {
        display: isWidthCalculated ? 'block' : 'none'
      }
    }, this.props.render ? this.props.render({
      width
    }) : this.props.children));

    if (this.props.showSizeWrapper) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: _style.default.wrapper
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: _style.default.info
      }, "Width: ", this.props.size.width), result);
    }

    return result;
  }

}

_defineProperty(Component, "propTypes", {
  size: _propTypes.default.object,
  children: _propTypes.default.node,

  /** Unique string helping for saving calculated size in cache */
  handle: _propTypes.default.string,

  /** CSS Module Stylesheet */
  stylesheet: _propTypes.default.object.isRequired,

  /** @ignore Shows the width of the responsive wrapper in the upper right corner when true. */
  showSizeWrapper: _propTypes.default.bool,

  /** Allows the user to alter the breakpoints for the size classes above. */
  widthBreakpoints: _propTypes.default.object,
  render: _propTypes.default.func
});

_defineProperty(Component, "defaultProps", {
  size: {},
  handle: 'handle',
  showSizeWrapper: false,
  widthBreakpoints: {
    xsmall: 768,
    small: 992,
    medium: 1200
  }
});

var _default = (0, _reactSizeme.default)({
  noPlaceholder: true
})(Component);

exports.default = _default;